"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = replaceBucketKeysWithUndefined;

var _utils = require("./utils");

var _joinSeparator = _interopRequireDefault(require("./constants/joinSeparator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @module replaceBucketKeysWithUndefined */

/**
 * Takes a data object and substitutedKeys then removes image url with undefined.
 * This is needed for image component to replace undefined image with appropriate placeholder
 *
 * @param {Object} data
 * @param {Array<SubstitutedKey>} substitutedKeys
 * @return {Object}
 */
function replaceBucketKeysWithUndefined({
  data,
  substitutedKeys
}) {
  if (Array.isArray(data)) {
    return data.map(item => replaceBucketKeysWithUndefined({
      data: item,
      substitutedKeys
    }));
  }

  const paths = (0, _utils.getPathsFromData)(data, substitutedKeys);

  if (!paths.length) {
    return data;
  }

  return paths.reduce((modifiedData, path) => {
    const keys = path.split(_joinSeparator.default);
    const lastKey = keys[keys.length - 1];
    const bottomNestedObject = keys.reduce((currentNestedObject, key) => key === lastKey ? currentNestedObject : currentNestedObject[key], modifiedData);
    bottomNestedObject[lastKey] = void 0;
    return modifiedData;
  }, JSON.parse(JSON.stringify(data)));
}